import { gsap } from '../../global/gsap';

const initHero = () => {
    const hero = document.querySelector('.js-hero');

    if (hero) {
        const heroTl = gsap.timeline({
            defaults: {
                ease: 'power3.out',
                overwrite: true
            },
            scrollTrigger: {
                trigger: hero,
                start: 'bottom bottom',
                end: `bottom+=${window.innerHeight} top`,
                pin: true,
                pinSpacing: false,
                anticipatePin: 1,
                fastScrollEnd: true,
                invalidateOnRefresh: true,
                scrub: 0.5
            }
        });

        heroTl.to(hero, {
            opacity: 0
        });
    }
};

export { initHero as default };
